export default __webpack_public_path__ + "17938f18459a80a5b557f50b2b12ff6d.svg";